import _isError from "lodash/isError";
import _isEmpty from "lodash/isEmpty";
import * as React from 'react';
import useAsync from 'react-use/lib/useAsync';
import { fetchExerciseWithProgress } from '../api/fetchExercise';
export const ExerciseLoader = _ref => {
  let {
    children,
    environment,
    exerciseId,
    getData,
    language,
    nextIds,
    onError,
    setData,
    validate
  } = _ref;
  const exercise = getData(exerciseId);
  const {
    error
  } = useAsync(async () => {
    if (!_isEmpty(exercise)) {
      return;
    }
    const exerciseData = await fetchExerciseWithProgress(exerciseId, environment, language, validate);
    setData(exerciseId, exerciseData);
  }, [exerciseId, exercise]);
  React.useEffect(() => {
    if (_isError(error)) {
      onError(error);
    }
  }, [error, onError]);

  // Try to pre-fetch next exercises in a parallel
  React.useEffect(() => {
    nextIds.forEach(id => {
      if (!_isEmpty(getData(id))) {
        return;
      }
      fetchExerciseWithProgress(id, environment, language, validate).then(exerciseData => {
        setData(id, exerciseData);
      }).catch(onError);
    });
  }, [environment, language, getData, nextIds, setData, validate, onError]);
  return React.useMemo(() => children({
    error,
    exercise
  }), [children, exercise, error]);
};